import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },

  '.group-parent-container': {
    '& .home-static-hero-wrapper': {
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.surface.pricing,
        color: palette.text.highlight,
        '&:hover': {
          backgroundColor: palette.text.highlight,
          color: palette.surface.pricing,
        },
      },
    },
    '& .normal-text': {
      fontWeight: 400,
      fontFamily: 'Gilda Display !important',
      fontSize: '64px !important',
      lineHeight: '72px !important',
      letterSpacing: '-0.64px !important',
      '@media (min-width: 600px) and (max-width: 1024px)': {
        fontSize: '52px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.04px !important',
      },
      '@media (max-width: 600px)': {
        fontSize: '44px !important',
        lineHeight: '48px !important',
        letterSpacing: '-0.88px !important',
      },
    },
    '& .hero-home-button': {
      color: palette.text.highlight,
      borderColor: palette.text.highlight,

      '&:hover': {
        borderColor: palette.text.highlight,
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      marginTop: 88,
      background: `
          linear-gradient(
            rgba(0, 32, 21, 0.7), 
            rgba(0, 32, 21, 0.7)
          ),
          url('/images/hero-other.jpg')
          no-repeat center center
        `,
      backgroundSize: 'cover',
      '& .hero-header-title': {
        fontFamily: 'Gilda Display !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
      },

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
      },
      '& .MuiSwitch-track': {
        border: 'none',
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-variant-2': {
      marginTop: '68px',
    },
    '& .home-hero-wrapper': {
      width: '100vw',
      zIndex: 2,
      '& .section-alternate': {
        backgroundColor: palette.text.primary,
        '& .section-alternate__content': {
          objectFit: 'contain',
          display: 'flex',
          justifyContent: 'center',
          '& .section-header__title-wrapper': {
            maxWidth: '640px',
            '@media (min-width: 600px) and (max-width: 1200px)': {
              maxWidth: '520px',
            },
          },
          '& .section-header__cta-wrapper': {
            display: 'flex',
            flexDirection: 'row',
            maxWidth: '90vw',
            '& .login-button': {
              backgroundColor: palette.secondary.light,
              color: palette.text.contrastText,
            },
          },
          zIndex: 3,
        },
      },
      '& .MuiGrid-container': {
        width: 878,
        display: 'flex',
        justifyContent: 'center',
        '@media screen and (max-width: 900px)': {
          width: '100%',
        },
      },

      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.surface.header,
        '@media screen and (max-width: 600px)': {
          height: '450px',
        },
        '@media screen and (min-width: 2560px)': {
          objectFit: 'cover',
        },
      },
      '& .home-hero-pretitle-stack': {
        alignItems: 'center',
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '600px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },

      '& .home-hero-title': {
        fontSize: 56,
        lineHeight: '64px',
        letterSpacing: '-1.12px',
        fontWeight: 400,
        justifyContent: 'center',
        textAlign: 'center',
        color: palette.text.highlight,
        fontFamily: 'Safiar Signature !important',
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      '& .definition-variant-3': {
        paddingInline: '56px !important',
        '@media(max-width: 600px)': {
          paddingInline: '24px !important',
        },
      },
      '@media(max-width: 1200px)': {
        padding: '20px !important',
        paddingBottom: '60px !important',
      },
      backgroundColor: palette.background.secondary,
      '& .benefits-wrapper': {
        '& .customImageWrapper': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'stretch',
          width: '100% !important',
          overflow: 'hidden',
          position: 'relative',
          '@media(max-width: 600px)': {
            height: '382px !important',
            minHeight: '382px !important',
          },
          '@media(min-width: 600px) and (max-width: 1200px)': {
            height: '400px !important',
            minHeight: '400px !important',
          },
          '@media(min-width: 1200px)': {
            height: '800px !important',
            minHeight: '800px !important',
          },
          '& .lazy-load-image-background': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            display: 'block !important',
            position: 'relative',
            borderRadius: '12px',
            overflow: 'hidden',
            '& img, & .image': {
              width: '100% !important',
              height: '100% !important',
              minHeight: '100% !important',
              objectFit: 'cover !important',
              display: 'block !important',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '24px',
            },
          },
          '& img, & .image': {
            width: '100% !important',
            height: '100% !important',
            minHeight: '100% !important',
            objectFit: 'cover !important',
            display: 'block !important',
            borderRadius: '24px',
          },
        },
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px 16px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-service-tile': {
        borderBottom: `0.5px solid ${palette.background.border} !important`,
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
      },
      '& .definition-service-header': {
        marginBottom: 24,
      },
      '& .definition-service-title': {
        fontWeight: 400,
        fontFamily: 'Gilda Display !important',
        fontSize: '28px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.28px !important',
      },
      '& .definition-service-description': {
        marginBottom: 0,
        fontSize: '18px !important',
        lineHeight: '26px !important',
        color: palette.text.tertiary,
      },
      '& .section-header__title': {
        fontWeight: 400,
        whiteSpace: 'pre-line',
        fontFamily: 'Gilda Display !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.68px !important',
        '&::first-line': {
          color: palette.text.brand,
          fontFamily: 'Safiar Signature !important',
        },
        paddingBottom: '24px !important',
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '48px !important',
          lineHeight: '48px !important',
          letterSpacing: '-0.96px !important',
        },
        '@media(max-width: 600px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      padding: '0px 16px !important',
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
        backgroundImage: `
          url(/images/home-images/image.webp),
          url(/images/home-images/image-rotated.webp)
        `,
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundSize: '300px, 300px',
        backgroundPosition: 'top right, bottom left',
      },
      '& .section-header__title, .summary-text, .summary-subtext, .subscription-tabs-label':
      {
        color: `${palette.text.primary} !important`,
      },
      '& .section-header__title': {
        fontWeight: 400,
        fontFamily: 'Gilda Display !important',
        fontSize: '56px !important',
        lineHeight: '64px !important',
        letterSpacing: '-1.68px !important',
        whiteSpace: 'pre-line',
        '&::first-line': {
          color: palette.text.brand,
          fontFamily: 'Safiar Signature !important',
        },
        '@media screen and (max-width: 700px)': {
          fontSize: '44px !important',
          lineHeight: '44px !important',
          letterSpacing: '-0.88px !important',
        },
      },
      '& .section-header__subtitle': {
        fontWeight: 400,
        fontFamily: 'Futura !important',
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.56px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
        },
      },
      '& .summary-text': {
        fontWeight: 400,
      },
      '& #pricing-benefit-section': {
        '& .react-multi-carousel-list': {
          width: '100% !important',
          maxWidth: '100% !important',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'center',
        },
        '& .react-multi-carousel-track': {
          width: '100% !important',
          display: 'flex !important',
          '@media(max-width: 1199px)': {
            margin: '0 auto',
            flexDirection: 'column',
            transform: 'none !important',
          },
        },
        '& .react-multi-carousel-list [aria-label="carousel-left-btn"], & .react-multi-carousel-list [aria-label="carousel-right-btn"]':
          {
            position: 'absolute',
            bottom: 0,
            zIndex: 1,
            '@media(max-width: 1199px)': {
              display: 'none !important',
            },
          },
        '& .react-multi-carousel-dot-list': {
          '@media(max-width: 1199px)': {
            display: 'none !important',
          },
        },
        '& .plan-card-grid-cell': {
          '@media(max-width: 1199px)': {
            margin: '0 auto',
          },
        },
        '& .react-multi-carousel-item': {
          width: '100% !important',
          minWidth: '100% !important',
          maxWidth: '100% !important',
          flexShrink: '0 !important',
          '@media(max-width: 1199px)': {
            display: 'flex',
            justifyContent: 'center',
            height: 'auto !important',
            overflow: 'visible !important',
          },
        },
        '& .carousel-single-item': {
          width: '100% !important',
          maxWidth: '100% !important',
          justifyContent: 'center !important',
          '@media(max-width: 1199px)': {
            margin: '0 auto',
            maxWidth: '100% !important',
          },
          '@media(min-width: 1200px)': {
            margin: '0 auto',
          },
        },
        '& .carousel-single-item > .MuiGrid-item': {
          '@media(max-width: 1199px)': {
            maxWidth: '100% !important',
            flexBasis: '100% !important',
            width: '100% !important',
          },
          '@media(min-width: 1200px)': {
            maxWidth: 'calc(33.333% - 16px) !important',
            flexBasis: 'calc(33.333% - 16px) !important',
            width: 'calc(33.333% - 16px) !important',
          },
        },
        '& .planCard': {
          width: '100% !important',
          fontWeight: 400,
          fontSize: '16px !important',
          lineHeight: '20px !important',
          letterSpacing: '-0.32px !important',
          border: 'none',
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
            '& hr': {
              color: palette.text.secondary,
            },
          },
          '& .MuiButton-outlinedPrimary': {
            color: palette.secondary.contrastText,
            '&:hover': {
              backgroundColor: palette.primary.main,
              color: palette.primary.contrastText,
              transition: 'none !important',
            },
          },
          '& .price-value': {
            fontWeight: 400,
            fontFamily: 'Gilda Display !important',
            fontSize: '40px !important',
            lineHeight: '40px !important',
            letterSpacing: '-0.8px !important',
          },
          '& .customcardTitle': {
            fontWeight: 400,
            fontFamily: 'Gilda Display !important',
            fontSize: '32px !important',
            lineHeight: '32px !important',
            letterSpacing: '-0.64px !important',
          },
          '& .customSubscriberName': {
            fontSize: '16px !important',
            color: palette.text.secondary,
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
          },
          '& .bold': {
            fontSize: '24px !important',
            color: palette.text.secondary,
            lineHeight: '24px !important',
            letterSpacing: '-0.48px !important',
          },
          '& .disclaimerContainer': {
            '& .customUpfrontWrapper': {
              paddingLeft: '15px !important',
              width: '100% !important',
            },
            '& .disclaimerText': {
              fontSize: '18px !important',
              color: palette.text.tertiary,
            },
            '& .bold': {
              fontSize: '18px !important',
              lineHeight: '20px !important',
              color: palette.text.tertiary,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 720,

            '@media(min-width: 900px)': {
              margin: '0px auto 32px',
            },
            '@media(max-width: 900px)': {
              margin: '0px auto 32px',
            },
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .summary-text': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.56px !important',
          color: `${palette.text.secondary} !important`,
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.4px !important',
          },
        },
        '& .summary-subtext': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.56px !important',
          color: `${palette.text.secondary} !important`,
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '24px !important',
            letterSpacing: '-0.4px !important',
          },
        },
        '& .savings-summary-link': {
          color: `${palette.text.secondary} !important`,
          textDecoration: 'underline',
          cursor: 'pointer',
          '@media(max-width: 600px)': {
            fontSize: '20px !important',
            lineHeight: '20px !important',
            letterSpacing: '-0.32px !important',
          },
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.light,
      '& .section': {
        '@media(min-width: 600px)': {
          padding: '40px 64px !important',
        },
        '@media(max-width: 600px)': {
          padding: '24px 20px !important',
        },
      },

      '& .cover-image-wrapper': {
        display: 'flex !important',
        justifyContent: 'center',
        alignItems: 'stretch',
        width: '100% !important',
        overflow: 'hidden',
        position: 'relative',
        '@media(min-width: 600px) and (max-width: 1024px)': {
          height: '500px !important',
          minHeight: '500px !important',
        },
        '@media(min-width: 1024px)': {
          height: '560px !important',
          minHeight: '560px !important',
        },
        '@media(max-width: 600px)': {
          height: '382px !important',
          minHeight: '382px !important',
        },
        '& img, & .image, & .how-cover-image': {
          width: '100% !important',
          height: '100% !important',
          minHeight: '100% !important',
          objectFit: 'cover !important',
          display: 'block !important',
          position: 'absolute',
          top: 0,
          left: 0,
          borderRadius: '24px',
        },
      },
      '& .howitworks-title': {
        '& .section-header__title': {
          whiteSpace: 'pre-line',
          fontFamily: 'Gilda Display !important',
          fontSize: '52px !important',
          lineHeight: '56px !important',
          letterSpacing: '-1.04px !important',
          '&::first-line': {
            color: palette.text.brand,
            fontFamily: 'Safiar Signature !important',
          },
          fontWeight: 400,
          '@media(min-width: 600px) and (max-width: 1024px)': {
            fontSize: '48px !important',
            lineHeight: '48px !important',
            letterSpacing: '-0.96px !important',
          },
          '@media(max-width: 600px)': {
            fontSize: '44px !important',
            lineHeight: '44px !important',
            letterSpacing: '-0.88px !important',
          },
        },
        '& .section-header__subtitle': {
          fontWeight: 400,
          fontSize: '24px !important',
          lineHeight: '28px !important',
          letterSpacing: '-0.56px !important',
        },
        marginBottom: 40,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
        paddingLeft: '0 !important',
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.background.tableHead,
        color: palette.secondary.main,
        fontSize: 15,
      },

      '& .working-steps-container': {
        maxWidth: '560px',
        '& .step-title': {
          fontSize: 24,
          lineHeight: '24px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
        '& .step-content': {
          fontSize: 18,
          color: palette.text.tertiary,
          lineHeight: '22px !important',
          letterSpacing: '-0.36px !important',
          fontWeight: 400,
        },
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '40px',
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: `
          linear-gradient(
            rgba(0, 32, 21, 0.7), 
            rgba(0, 32, 21, 0.7)
          ),
          url('/images/hero-other.jpg')
          no-repeat center center
        `,
        backgroundSize: 'cover',
        '& .hero-home-button': {
          background: `${palette.secondary.light} !important`,
        },
      },
      '& .section-header': {
        '& .hero-header-title': {
          fontFamily: 'Gilda Display !important',
          fontSize: '40px !important',
          lineHeight: '40px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 400,
        },
        '& .hero-header-subtitle': {
          fontFamily: 'Futura !important',
          fontSize: '20px !important',
          lineHeight: '22px !important',
          letterSpacing: '-0.4px !important',
          fontWeight: 400,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 0px 0px 0px !important',
        backgroundColor: palette.surface.light,
      },

      '& .footer-bar': {
        backgroundColor: `${palette.background.offer} !important`,
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
      '& .MuiButton-containedSecondary': {
        backgroundColor: palette.primary.main,
        color: palette.text.highlight,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .section-alternate': {
        '& .section-alternate__content': {
          paddingInline: '0 !important',
        },
        '@media(min-width: 900px)': {
          height: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.surface.pricing} !important`,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontWeight: 400,
        fontFamily: 'Gilda Display !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        '@media screen and (max-width: 700px)': {
          fontSize: '30px !important',
          lineHeight: '30px !important',
          letterSpacing: '-0.6px !important',
        },
      },
      '& .section-header__subtitle': {
        color: palette.text.secondary,
        fontWeight: 400,
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .hero-header-title': {
        fontFamily: 'Futura !important',
        fontSize: '48px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.96px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Futura !important',
        fontSize: '18px !important',
        lineHeight: '22px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 500,
      },
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.text.highlight,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        background: `${palette.text.highlight} !important`,
        border: `1px solid ${palette.primary.main} !important`,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .MuiButton-contained': {
        backgroundColor: palette.text.highlight,
        color: palette.text.primary,
      },
      '& .hero-header-title': {
        fontFamily: 'Gilda Display !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
      },
      '& .hero-header-subtitle': {
        fontFamily: 'Futura !important',
        fontSize: '20px !important',
        lineHeight: '24px !important',
        letterSpacing: '-0.4px !important',
        fontWeight: 400,
      },
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
        '& .hero-home-button': {
          background: `${palette.secondary.light} !important`,
        },
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
      '& .faq-link': {
        fontSize: '15px !important',
      },
      '& .accorion__item-title-container': {
        '& .MuiTypography-subtitle1': {
          fontSize: '20px !important',
          lineHeight: '24px !important',
          letterSpacing: '-0.8px !important',
          fontWeight: 500,
        },
      },
      '& .accordion__collapsable-text': {
        color: palette.text.secondary,
        fontSize: '16px !important',
        lineHeight: '20px !important',
        letterSpacing: '-0.32px !important',
        fontWeight: 400,
      },
    },
    '& .faq-contact-section': {
      background: `${palette.surface.light} !important`,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      paddingInline: '80px !important',
      '@media(max-width: 700px)': {
        paddingInline: '20px !important',
      },
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-title': {
        fontFamily: 'Gilda Display !important',
        fontSize: '40px !important',
        lineHeight: '40px !important',
        letterSpacing: '-0.8px !important',
        fontWeight: 400,
        '@media(max-width: 600px)': {
          fontSize: '32px !important',
          lineHeight: '32px !important',
          letterSpacing: '-0.64px !important',
        },
        '@media(min-width: 600px) and (max-width: 1200px)': {
          fontSize: '36px !important',
          lineHeight: '36px !important',
          letterSpacing: '-0.72px !important',
        },
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
        fontSize: '24px !important',
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
      },
      '& .provider-contact-details': {
        fontSize: '18px !important',
        fontFamily: 'Futura !important',
        lineHeight: '18px !important',
        letterSpacing: '-0.36px !important',
        fontWeight: 400,
      },
      '& .provider-contact-link': {
        color: palette.text.secondary,
        fontSize: 24,
        lineHeight: '28px !important',
        letterSpacing: '-0.48px !important',
        fontWeight: 400,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        whiteSpace: 'normal',
        maxWidth: '100%',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    '& .success-wrapper': {
      marginTop: 120,
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.surface.grey,
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      maxWidth: '598px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.surface.light,
        color: palette.surface.light,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.surface.light,

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        fill: `${palette.surface.light} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.surface.light,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        fill: `${palette.surface.light} !important`, // Filled background
        color: palette.text.highlight,
        '& .MuiSvgIcon-root': {
          color: palette.surface.light,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.surface.light, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: `${palette.surface.light} !important`,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      },
    },

    '& .stepperItems': {
      marginTop: 24,
    },

    '& .footer-wrapper': {
      paddingInline: '40px !important',
      '@media(max-width: 700px)': {
        paddingInline: '10px !important',
      },
    },
  },
};
